export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "grandslotbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "grandslotbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
